<p class="message">
  <span>{{ 'PrivacyPolicyPopup.Message' | translate }} </span>
  <a [routerLink]="'/page/privacy-policy' | currentLangLink">{{ 'PrivacyPolicyPopup.LinkText' | translate }}</a>.
</p>
<button class="btn btn-warning" (click)="confirmPrivacyPolicy()">{{ 'PrivacyPolicyPopup.Button' | translate }}</button>
